import { render, staticRenderFns } from "./RegcodeInfoText.vue?vue&type=template&id=4637013e&"
import script from "./RegcodeInfoText.vue?vue&type=script&lang=ts&"
export * from "./RegcodeInfoText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports